<template>
  <sc-grid
    name="sc-psl-table-all"
    :data="psls"
    :total="pslsCount"
    :loading="loading"
    @pagination="onPaginate"
    default-sort-column="created"
    default-sort-direction="desc"
    :has-backend-sorting="false">

    <template slot="table-columns" slot-scope="{ props }">
      <sc-table-column
        label="ID PLP Intelipost"
        field="id"
        sortable>
        <a
          v-if="redirectIsEnabled(props.row.localized_status)"
          :href="getUrl(props.row)">
          {{ props.row.id }}
        </a>
        <span v-else>
          {{ props.row.id }}
        </span>
      </sc-table-column>

      <sc-table-column
        label="ID PLP Transportadora"
        field="psl_id_in_logistic_provider"
        sortable>
        <span v-if="props.row.psl_id_in_logistic_provider">
          {{ props.row.psl_id_in_logistic_provider }}
        </span>
      </sc-table-column>

      <sc-table-column
        label="ID PLP Embarcadora"
        field="shippers"
        sortable>
        <ul>
          <li
            v-for="shipper in props.row.shippers"
            :key="shipper.id">
            {{ shipper.id }}
          </li>
        </ul>
      </sc-table-column>

      <sc-table-column
        label="Status"
        field="localized_status"
        sortable>
        <sc-tooltip
          position="is-right"
          type="is-danger"
          multilined
          :active="props.row.localized_status === 'UNAVAILABLE_LOGISTIC_PROVIDER'" 
          label="A transportadora estava indisponível. Mas não se preocupe, faremos um a nova tentativa em alguns minutos">
            <sc-localized-status :status="props.row.localized_status" />
        </sc-tooltip>
      </sc-table-column>

      <sc-table-column
        label="Data de criação"
        field="created"
        sortable>
        {{ props.row.created | date('DD/MM/YYYY - HH:mm') }}
      </sc-table-column>

      <sc-table-column
        label="Volumes (Qtd)"
        field="shipment_order.volumes.length"
        sortable>
        <template v-if="props.row.shipment_order.volumes">
          {{ props.row.shipment_order.volumes.length }}
        </template>
      </sc-table-column>

      <sc-table-column
        label="Métodos de entrega"
        field="delivery_method_names"
        sortable>
        <ul>
          <li
            v-for="deliveryMethod in props.row.logistic_provider.delivery_methods"
            :key="deliveryMethod.id">
            {{ deliveryMethod.name }}
          </li>
        </ul>
      </sc-table-column>

      <sc-table-column
        v-if="props.row.warehouse"
        label="Origem"
        field="warehouse.official_name"
        sortable>
        {{ props.row.warehouse.official_name }}
      </sc-table-column>

      <sc-table-column label="Ações">
        <sc-actions-menu :row="props.row" />
      </sc-table-column>
    </template>
  </sc-grid>
</template>
<script>
  import {
    ScForm,
    ScGrid,
    ScTableColumn,
    ScTooltip,
  } from '@intelipost-js/secure-components';
  import { Lodash } from '@intelipost-js/secure-providers';
  import { createNamespacedHelpers } from 'vuex';

  import ScActionsMenu from '../ScActionsMenu';
  import ScLocalizedStatus from '../ScLocalizedStatus';

  const { mapState, mapActions, mapMutations } = createNamespacedHelpers('psl/pslList');

  export default {
    name: 'sc-psl-list-table-all',
    data() {
      return {
        defaultFilter: {
          filters: null,
          pagination: {
            current: 1,
            limit: 10,
          },
        },
      };
    },
    computed: {
      ...mapState([
        'loading',
        'psls',
        'pslsCount',
        'searchMethod',
      ]),
    },
    methods: {
      ...mapActions([
        'searchByLogisticProvider',
      ]),
      ...mapMutations([
        'setPagination',
      ]),
      onPaginate(config) {
        const { pagination = {} } = config;

        this.setPagination(Lodash.cloneDeep(pagination));
        this.searchByLogisticProvider();
      },
      getUrl(row) {
        const { id = null } = row || {};

        return `/ng#/plp/${id}/`;
      },
      redirectIsEnabled(localizedStatus = null) {
        return !(localizedStatus === 'WAITING_IN_QUEUE' ||
          localizedStatus === 'PROCESSING' ||
          localizedStatus === 'TO_BE_PROCESSED' ||
          localizedStatus === 'NOT_SENT');
      },
    },
    components: {
      ScActionsMenu,
      ScForm,
      ScGrid,
      ScLocalizedStatus,
      ScTableColumn,
      ScTooltip,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-psl/features/list/components/sc-psl-list-tables/ScPslListTableAll.vue?6f721572